<template>
    <v-main>
        <div class="stepper-5">
            <div id="move-step5">
                <StepperBar
                    v-if="registrationFormDetail"
                    :stepOn="StepperType"
                    :stepper="5"
                />
            </div>
        </div>
        <div v-if="!success">
            <FormData
                :step="step"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :registrationState="student_status"
                :result_type="result_type"
                v-if="registrationFormDetail && student_id"
                class="form-margin-top"
                @loadingUpdate="loadingUpdate"
            />
        </div>
        <div v-else>
            <StudentSummit
                :step="step"
                :registrationFormDetail="registrationFormDetail"
                :student_id="student_id"
                :success="success"
                :result_type="result_type"
                v-if="registrationFormDetail && student_id"
                @loadingUpdate="loadingUpdate"
            />
        </div>
    </v-main>
</template>

<script>
import StepperBar from "./StepperBar";
import FormData from "./FormData";
import StudentSummit from "./formPartial/StudentSummit.vue";

export default {
    name: "StepFive",
    components: { StepperBar, FormData, StudentSummit },
    data: () => ({
        step: 5,
    }),
    props: {
        registrationFormDetail: Object,
        student_id: Number,
        success: Boolean,
        result_type: String,
        student_status: String,
    },
    computed: {
        StepperType() {
            if (
                this.registrationFormDetail != null &&
                !(
                    this.registrationFormDetail?.fee == 0 ||
                    this.registrationFormDetail?.fee == null
                )
            )
                return true;
            else return false;
        },
    },
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
    },
    mounted() {},
};
</script>